import { render, staticRenderFns } from "./FilterReceived.vue?vue&type=template&id=6862958d"
import script from "./FilterReceived.vue?vue&type=script&lang=js"
export * from "./FilterReceived.vue?vue&type=script&lang=js"
import style0 from "./FilterReceived.vue?vue&type=style&index=0&id=6862958d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports